import { render, staticRenderFns } from "./dialog-excel-upload-header.vue?vue&type=template&id=2a0bcfd6&"
import script from "./dialog-excel-upload-header.vue?vue&type=script&lang=js&"
export * from "./dialog-excel-upload-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports